import PropTypes from "prop-types";
import React, { Fragment, useState } from "react";
import Pg from '../../../../shared/components/CustomParagraph';
import Div from '../../../../shared/components/CustomDiv';
import H1 from '../../../../shared/components/CustomH1';
import { useDrop } from 'react-dnd';
import { Avatar } from '@material-ui/core';

// Who Are We
const TripleBlockList = (props) => {
    const [hover, setHover] = useState(false);

    let { 
        preview = false,  
        id = null, 
        data = null,
        inputCallback = null,
        update = null
    } = props;

    const [collectedProps, drop] = useDrop({
        accept: ['media'],
        drop: (item) => {
        data.inputs['backgroundImage'].value = item.media.node;
        update();
        }
    });

    const style = {
        boxShadow: 'none',
        backgroundColor: 'white',
        backgroundPosition: 'center center',
        backgroundSize: 'cover',
        position: 'relative',
        width: '100%',
        minHeight: '700px',
        maxHeight: '880px',
        marginBottom: 20
    };

    let poles = data.blocks.polesBlocks;
    return (
        <div
        className={`offer-template-scope`}  
        ref={drop} 
        onMouseEnter={() => setHover(true)} 
        onMouseLeave={() => setHover(false)}
        style={{
            ...style,
        }}
        >
            { !preview && props.children }
            <div className="container">
                <div className="breacrumb">
                    <Div data={data} className="category" preview={preview} component={id} block={'category'} inputCallback={inputCallback} nopadding={true} style={{backgroundColor: data?.inputs?.primaryColor.value, color: data?.inputs?.secondaryColor.value}} />
                    <Div data={data} className="sub-category" preview={preview} component={id} block={'sub_category'} inputCallback={inputCallback} nopadding={true} style={{color: data?.inputs?.primaryColor.value, backgroundColor: data?.inputs?.secondaryColor.value}} />
                </div>
                <div className="container-blocs type-list">
                    {
                        poles.config.map((pole, index) => (
                            <div className="bloc-list">
                                <div className="title-bloc">Pôle</div>
                                <div className="container-list">
                                    {
                                        pole.blocks.title.inputs.value.value ? (
                                            <div className="title-list">{pole.blocks.title.inputs.value.value}</div>
                                        ) : null
                                    }
                                    {
                                        pole.blocks.leadersBlocks.config.map((leader, index) => (
                                            <div className="item-list">
                                                <div className="avatar">
                                                    <Avatar 
                                                        src={
                                                            typeof leader.blocks.leader.inputs.image.value === 'string' ? 
                                                                leader.blocks.leader.inputs.image.value : 
                                                                leader.blocks.leader.inputs.image.value?.filePath ? 
                                                                    ` ${process.env.REACT_APP_MEDIAS}/${leader.blocks.leader.inputs.image.value?.filePath}` 
                                                                    : "https://via.placeholder.com/80/F0F7FA/C5DEEC"
                                                        }
                                                        style={{width: 80, height: 80}}
                                                        alt={leader.blocks.leader.inputs.name.value}
                                                    />
                                                </div>
                                                <div className="infos">
                                                    <div className="nom">{leader.blocks.leader.inputs.name.value}</div>
                                                    <div className="role">{leader.blocks.leader.inputs.poste.value}</div>
                                                </div>
                                            </div>
                                        ))
                                    }
                                    {
                                        pole.blocks.moreInfo.inputs.value.value ? (
                                            <div className="infos-sup text-right">{pole.blocks.moreInfo.inputs.value.value}</div>
                                        ) : null
                                    }
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    );
};

TripleBlockList.propTypes = {
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string
};

export default TripleBlockList;
